import { isEmpty } from 'ramda';
import { makeStyles } from '@material-ui/core/styles';
import { IntlProviderType } from 'components/IntlProvider';

interface WizardValuesTypes {
  category?: string;
  subcategory?: string;
  segments?: [];
  research_goal?: string;
  audience_gender?: string;
  audience_country?: [];
  brand?: string;
  name?: string;
}

interface WizardErrorsTypes {
  category?: string;
  subcategory?: string;
  segments?: string;
  research_goal?: string;
  audience_gender?: string;
  _error?: string;
  audience_country?: string;
  brand?: string;
  name?: string;
}

export const validate = (
  values: WizardValuesTypes,
  { intl }: { intl: IntlProviderType }
) => {
  const errors: WizardErrorsTypes = {};
  if (!values.category) {
    errors.category = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  if (!values.subcategory) {
    errors.subcategory = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  if (!values.segments || isEmpty(values.segments)) {
    errors.segments = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  if (!values.research_goal) {
    errors.research_goal = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  if (!values.audience_gender) {
    errors.audience_gender = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  if (!values.audience_country || isEmpty(values.audience_country)) {
    errors.audience_country = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  if (!values.brand) {
    errors.brand = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  if (!values.name) {
    errors.name = intl.formatMessage({
      id: 'errors.fields.required',
      defaultMessage: 'Field is required',
    });
  }
  return errors;
};

export const wizardStyles = makeStyles((theme) => ({
  slider: {
    padding: theme.spacing(1, 2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    marginBottom: theme.spacing(2),
  },
  summary: {
    fontWeight: 600,
    margin: 0,
  },
  submitButton: {
    marginTop: theme.spacing(2),
    fontSize: '0.875rem',
    backgroundColor: '#000',
    color: '#fff',
    border: 'solid 1px #000',
    padding: '0.5rem 0.75rem',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000',
    },
  },
  secondaryButton: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    fontSize: '0.875rem',
    backgroundColor: '#fff',
    color: '#000',
    border: 'solid 1px #fff',
    padding: '0.5rem 0.75rem',
    '&:hover': {
      color: '#0055ab',
      backgroundColor: '#fff',
    },
  },
}));
